import React from 'react';
import ReserveFieldResourcesList from '@/components/reserve/ReserveFieldResourcesList/ReserveFieldResourcesList';
import { useReserveForm } from '../ReserveFormProvider';

export const ReserveFormResources: React.FC = () => {
  const {
    form,
    resourceType,
    currentOfficeId,
    defaultResource,
    updatedResourcesList
  } = useReserveForm();
  return (
    <ReserveFieldResourcesList
      form={form}
      errors={form.formState.errors}
      resourceType={resourceType}
      officeId={currentOfficeId}
      resourcesList={updatedResourcesList}
      defaultValue={defaultResource}
    />
  );
};
